module.exports = __webpack_public_path__ + "static/img/official.3e10bea1.svg";